/** Shared colour vocabulary so everything reads as one pixel-art set. */
export const C = {
  outline: '#171822',
  visibility: '#a8e3d6',
  black: '#0b0810',
  white: '#f4f0e6',
  skin: '#f7d9b9',
  skinShade: '#e2a985',
  skinPale: '#ede4d8',
  eye: '#1d1526',
  blush: '#f0a3a0',

  hair: {
    black: '#2b2233', blackHi: '#4a3d57',
    brown: '#6b4226', brownHi: '#8f5b37',
    blonde: '#e9c96f', blondeHi: '#f6e2a3',
    red: '#b8432c', redHi: '#d9684d',
    blue: '#3d5ea6', blueHi: '#5f80c8',
    pink: '#e07aa8', pinkHi: '#f0a4c4',
    white: '#d9d6dc', whiteHi: '#f1eef4',
    green: '#4a8f5a', greenHi: '#6db37c',
  },
  cloth: {
    red: '#c8433d', redSh: '#95302c',
    blue: '#3b6fc7', blueSh: '#2a4f93',
    yellow: '#e2b53c', yellowSh: '#b78a24',
    green: '#4f9d5a', greenSh: '#377241',
    purple: '#8a5bb8', purpleSh: '#653f8b',
    orange: '#e07b2c', orangeSh: '#b05a1a',
    teal: '#3aa1a1', tealSh: '#277474',
    white: '#eeeeee', whiteSh: '#c4c4cc',
    pink: '#f28cb1', pinkSh: '#c96a8d',
    gray: '#8a8a95', graySh: '#63636d',
  },
  pants: {
    navy: '#2c3557', brown: '#5a3d2b', gray: '#575768', black: '#2a2a33', olive: '#4f5a35', wine: '#6a2d3f',
  },
  shoe: '#3a2a2a',

  // world
  wood: '#735341', woodDk: '#594332', woodLt: '#89674c', woodLine: '#40332e',
  woodPale: '#b8925f', woodPaleDk: '#9a7548',
  carpetRed: '#69333e', carpetRedDk: '#502934', carpetRedLt: '#82434b', carpetGold: '#c9a24a',
  carpetBlue: '#2f3f7a', carpetBlueDk: '#243161', carpetBlueLt: '#40529a',
  carpetGreen: '#3a6b45', carpetGreenDk: '#2a4f33',
  stone: '#7c7c86', stoneDk: '#5f5f69', stoneLt: '#9a9aa4', stoneLine: '#4a4a54',
  tileA: '#d9d2c1', tileB: '#3e3a44',
  dirt: '#4f3a2a', dirtDk: '#3c2b1e', dirtLt: '#63493a',
  brick: '#5a3d3d', brickDk: '#42292b', brickLt: '#70504f', mortar: '#2f2226',
  wallTop: '#1e1a26', wallTopLt: '#2c2738',
  paperGreen: '#5a6e52', paperGreenDk: '#46583f', paperGreenLt: '#6f8466',
  paperRed: '#6f3a3f', paperRedDk: '#55292d', paperRedLt: '#87494f',
  paperBlue: '#3f4a6b', paperBlueDk: '#2f3752', paperBlueLt: '#4f5d84',
  paperCream: '#b8ab8c', paperCreamDk: '#9a8e71', paperCreamLt: '#cfc3a5',
  panel: '#5b3b25', panelDk: '#44291a', panelLt: '#754f34',
  plaster: '#8c8578', plasterDk: '#6e6858', plasterLt: '#a39c8d',
  dado: '#3b2a1e',
  metal: '#7f8590', metalDk: '#555a63', metalLt: '#aab0ba',
  brass: '#c9a24a', brassDk: '#9a7830',
  glass: '#8fb4c8', glassLt: '#c4e0ee', night: '#1a2340', moon: '#dfe6ff',
  fabricGreen: '#3f7a52', fabricGreenDk: '#2d5a3b', fabricRed: '#a33a3a', fabricRedDk: '#7a2828',
  fabricBlue: '#3a5a9a', fabricBlueDk: '#2b4373', sheet: '#e8e2d2', sheetSh: '#c9c2b0', pillow: '#f5f1e6',
  leaf: '#4f9d5a', leafDk: '#357043', pot: '#a55a3a', potDk: '#7e3f27',
  fire: '#ffb347', fireHi: '#fff1a8', fireDk: '#e0552b',
  monster: '#242132', monsterLt: '#3c354e', monsterEdge: '#65536d', monsterEye: '#ffd23a', monsterEyeHi: '#fff6c8',
  paper: '#e6dcc0', paperDk: '#c7bb9b', ink: '#3a2f2a',
  bars: '#4e525c', barsLt: '#7a7f8a',
};
